export const formatCurrency = (num, separator = ' ') =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator); // 160 == Non-breakable space